module.exports = __webpack_public_path__ + "img/4-2-1-5-1-preview-colouring-page-e.167752d5.jpg";